/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable no-async-promise-executor */
/* eslint-disable max-len */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-console */
import requester from '../utils/requester';
import config from '../config';
import offlineDB from './index';

// for getting data from the server and save on offline database | server -> local
const syncOfflineDB = async () => {
    const result = await requester.authNeed().contentType('application/json').get(config.serverURL + '/token/check');
    if (result?.data?.results?.[0]?.token) {
        // every 10 min updates:
        const offlineDBLastUpdate = localStorage.getItem('offlineDBLastUpdate');
        const tenMin = 10 * 60 * 1000; // ms
        if (!offlineDBLastUpdate || (((new Date()) - (new Date(offlineDBLastUpdate))) > tenMin)) {
            try {
                localStorage.setItem('offlineDBLastUpdate', new Date());
                updateOfflineDB();
            }
            catch (err) {
                console.log(err);
            }
        }
        // daily updates:
        const offlineDBLastDailyUpdate = localStorage.getItem('offlineDBLastDailyUpdate');
        const oneDay = 24 * 60 * 60 * 1000; // ms
        if (!offlineDBLastDailyUpdate || (((new Date()) - (new Date(offlineDBLastUpdate))) > oneDay)) {
            try {
                localStorage.setItem('offlineDBLastDailyUpdate', new Date());
                updateOfflineDBDaily();
            }
            catch (err) {
                console.log(err);
            }
        }
    }
    else {
        localStorage.removeItem('offlineDBLastUpdate');
        localStorage.removeItem('offlineDBLastDailyUpdate');
    }
}

// Update handler for frequent updates
const updateOfflineDB = () => {
    const listEntitiesToUpdate = [
        { entity: 'animals', handlerMethod: 'addAnimalsList', requestUrl: '/animals?start=0&end=10000' },
        // { entity: 'farms', handlerMethod: 'addFarmsList', requestUrl: '/farms?start=0&end=1000' },
        { entity: 'groups', handlerMethod: 'addGroupsList', requestUrl: '/groups' },
        { entity: 'events', handlerMethod: 'addEventsList', requestUrl: '/s/events?start=0&end=30000' },
    ]
    for (const singleListEntity of listEntitiesToUpdate) {
        listUpdateHandler(singleListEntity.entity, singleListEntity.handlerMethod, singleListEntity.requestUrl);
    }
    updateUserInfoOnSideMenu();
};

// Update handler for daily updates
const updateOfflineDBDaily = () => {
    // listUpdateHandler('breeds', 'addBreedsList', '/breeds');
    updateMonthlyMethanes();
    updateWeeklyMethanes();
};

// this is a method to keep code DRY (a handler to fetch and update list entities)
const listUpdateHandler = (entity, handlerMethod, requestUrl) => new Promise(async (resolve, reject) => {
    try {
        const result = await requester.contentType('application/json').authNeed().get(config.serverURL + requestUrl);
        if (result?.data?.results?.length && Array.isArray(result.data.results)) {
            await offlineDB[entity][handlerMethod](result.data.results);
            resolve();
        }
        else {
            reject(`error - update ${entity} List`);
        }
    }
    catch {
        reject(`error - update ${entity} List`);
    }
});

const updateMonthlyMethanes = () => new Promise(async (resolve, reject) => {
    try {
        const animalsResult = await requester.authNeed().contentType('application/json').get(config.serverURL + `/data/bulk?periodInDays=30&startDate=${loadPastDate(365)}&endDate=${loadPastDate(0)}&start=0&end=6000`);
        const monthlyMethaneList = animalsResult?.data?.results ?? [];
        await offlineDB.monthlyMethane.addMonthlyMethanes(monthlyMethaneList);
        resolve();
    }
    catch (error) {
        reject('error - updateMonthlyMethanes', error);
    }
});

const updateWeeklyMethanes = () => new Promise(async (resolve, reject) => {
    try {
        const animalsResult = await requester.authNeed().contentType('application/json').get(config.serverURL + `/data/bulk?periodInDays=1&startDate=${loadPastDate(7)}&endDate=${loadPastDate(0)}&start=0&end=6000`);
        const weeklyMethaneList = animalsResult?.data?.results ?? [];
        await offlineDB.weeklyMethane.addWeeklyMethanes(weeklyMethaneList);
        resolve();
    }
    catch (error) {
        reject('error - updateWeeklyMethanes', error);
    }
});

const updateUserInfoOnSideMenu = () => new Promise(async (resolve, reject) => {
    try {
        const result = await requester.authNeed().contentType('application/json').get(config.serverURL + '/user');
        if (result.data.results) {
            const userInfo = result.data.results;
            const userInfoObject = { ...userInfo };
            const saveObject = { name: 'sideMenu', value: { ...userInfoObject } };
            await offlineDB.appData.add(saveObject);
            resolve();
        }
    }
    catch (error) {
        reject('error - updateUserInfoOnSideMenu', error);
    }
});

// Used in methane-related functions, below
const loadPastDate = (days) => {
    const d = new Date();
    const selectedDate = days ? new Date(d.setDate(d.getDate() - days)) : d;
    return selectedDate.toISOString();
}

export default syncOfflineDB;
